module.exports = __webpack_public_path__ + "media/public/img/tiktok-round-01-ca200c7ba8d03f2cade56905edf8567d.svg";